import { render, staticRenderFns } from "./ResetPassForm.vue?vue&type=template&id=60b2ba90&"
import script from "./ResetPassForm.vue?vue&type=script&lang=ts&"
export * from "./ResetPassForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports